/**
 * Scroll animations
 * - Animates elements when they come into view
 */

export function initScrollAnimations() {
  const animatedElements = document.querySelectorAll('.scroll-animation');
  
  // Function to check if an element is in viewport
  const isInViewport = (element) => {
    const rect = element.getBoundingClientRect();
    return (
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.8
    );
  };
  
  // Function to handle scroll and animate elements
  const handleScroll = () => {
    animatedElements.forEach((element) => {
      if (isInViewport(element)) {
        element.classList.add('active');
      }
    });
  };
  
  // Initial check for elements in viewport
  window.addEventListener('load', handleScroll);
  
  // Check for elements in viewport on scroll
  window.addEventListener('scroll', handleScroll);
}